import { CheckboxStyle } from '~/components/defaults/componentStyles/Checkbox.style'
import { IconStyle } from '~/components/defaults/componentStyles/Icon.style'
import { InputStyle } from '~/components/defaults/componentStyles/Input.style'
import { LinkStyle } from '~/components/defaults/componentStyles/Link.style'
import { skeletonTheme } from '~/components/defaults/componentStyles/Skeleton.style'
import { StepperStyle } from '~/components/defaults/componentStyles/Stepper.style'
import { SwitchStyle } from '~/components/defaults/componentStyles/Switch.style'
import { TagStyle } from '~/components/defaults/componentStyles/Tag.style'
import { TextStyle } from '~/components/defaults/componentStyles/Text.style'
import { TooltipStyle } from '~/components/defaults/componentStyles/TooltipStyle'
import { HighlightStyle } from '~/components/defaults/Highlight.style'
import { KbdStyle } from '~/components/shared/componentStyles/Kbd.style'

export const defaultComponentStyles = {
  components: {
    Checkbox: CheckboxStyle,
    Icon: IconStyle,
    Input: InputStyle,
    NumberInput: InputStyle,
    Stepper: StepperStyle,
    Switch: SwitchStyle,
    Tag: TagStyle,
    Text: TextStyle,
    Link: LinkStyle,
    Skeleton: skeletonTheme,
    Tooltip: TooltipStyle,
    Mark: HighlightStyle, //https://github.com/chakra-ui/chakra-ui/issues/7268#issuecomment-1399622290
    Kbd: KbdStyle,
  },
}
